import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=29155392&scoped=true"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=29155392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29155392",
  null
  
)

export default component.exports